import React, { useState, useEffect } from "react";
import { makeStyles } from '@material-ui/styles';
import {
  Switch,
  Route,
  withRouter
} from "react-router-dom";
import withShowToast from '../../../hocs/with_show_toast.js';
import { compose } from 'redux';

import SubscribeBlock from "./components/subscribe_block.js.jsx";

import Container from "../../../base/components/container.js";
import HtmlContent from "../../../base/components/html_content.js";

import ShowPageUseCase from "../../../use_cases/frontend/pages/show_page_use_case.js";
import SaveSubscriberUseCase from "../../../use_cases/downloadables/subscribers/save_subscriber_use_case.js";
import CreateTokenUseCase from "../../../use_cases/recaptcha/create_token_use_case.js.jsx";

import ContactsForm from "../../../base/components/contact_form.js";

import Routes from "../../routes.js";

import {
  NotFoundErrorCode
} from "../../../constants.js";
import routes from "../../routes.js";

const pageStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.MiddleBlue,
  },
  container: {
    backgroundColor: "white",
    padding: "80px 16px",
    fontSize: "20px",
    lineHeight: "30px",
    fontWeight: theme.typography.fontWeightLight,
    color: theme.palette.black,
    "& h1": {
      fontSize: "60px",
      lineHeight: "70px",
      fontWeight: theme.typography.fontWeightMedium,
      textTransform: "uppercase",
      color: theme.palette.blueMain,
      textShadow: "0px 2px 6px rgba(0, 0, 0, 0.18)",
      marginTop: "0px",
      marginBottom: "32px",
      ['@media (max-width: 768px)']: {
        fontSize: "20px",
        lineHeight: "26px",
        marginBottom: "14px",
        textShadow: "none",
      },
    },
    "& h2": {
      fontSize: "38px",
      fontWeight: theme.typography.fontWeightMedium,
      marginTop: "0px",
      marginBottom: "24px",
      ['@media (max-width: 768px)']: {
        fontSize: "20px",
        lineHeight: "26px",
        marginBottom: "16px",
      },
    },
    "& h3": {
      fontSize: "28px",
      fontWeight: theme.typography.fontWeightMedium,
      marginTop: "0px",
      marginBottom: "24px",
      ['@media (max-width: 768px)']: {
        fontSize: "14px",
        lineHeight: "20px",
        marginBottom: "14px",
      },
    },
    "& h4": {
      fontSize: "24px",
      fontWeight: theme.typography.fontWeightMedium,
      marginTop: "0px",
      marginBottom: "24px",
      ['@media (max-width: 768px)']: {
        fontSize: "14px",
        lineHeight: "20px",
        marginBottom: "14px",
      },
    },
    "& a": {
      color: theme.palette.grayText,
      textDecoration: "underline",
      wordBreak: "break-word"
    },
    "& p": {
      marginBottom: "30px",
      ['@media (max-width: 768px)']: {
        marginBottom: "24px",
      },
    },
    "& .image": {
      ['@media (max-width: 420px)']: {
        float: "none",
        marginLeft: "0",
        marginRight: "0",
        maxWidth: "100%",
        width: "100% !important"
      }
    },
    ['@media (max-width: 768px)']: {
      padding: "36px 24px",
      fontSize: "14px",
      lineHeight: "20px",
    },
  },
  contactForm: {
    maxWidth: "87%",
    margin: "50px 0 0",
    display: "block",
    width: "100%",
    ['@media (max-width: 992px)']: {
      marginTop: "28px",
      maxWidth: "100%",
    },
  }
}));

const subscribeAction = "downloadable_subscribe";

const StaticPage = (props) => {

  const { history } = props;

  const [page, setPage] = useState({});
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [subscribeEmail, setSubscribeEmail] = useState(props.currentUser ? props.currentUser.email : "");
  const { showSuccessMessage, showErrorMessage, showWarningMessage } = props;

  const subscribe = (event) => {
    event.preventDefault();

    if(downloadable) {
      setSubmitting(true)

      const params = {
        downloadable,
        email: subscribeEmail
      }

      grecaptcha.ready(() => {
        CreateTokenUseCase.execute(subscribeAction)
        .then(token => {
          return SaveSubscriberUseCase.execute(params, token)
        })
        .then(() => {
          setSubmitting(false);
          // showSuccessMessage(I18n.t("web.subscription.success"));

          history.push(routes.thankYouPage());
        })
        .catch(result => {
          const { message } = result;
          setSubmitting(false);
          showErrorMessage(message);
        })
      })
    }
  }

  useEffect(() => {
    const { identifier } = props;
    if(!identifier) {
      history.push(Routes.pageNotFound());
    }
    ShowPageUseCase.execute(identifier)
    .then((result) => {
      const { data: { page } } = result;
      setPage(page);
      setLoading(false);
    })
    .catch((result) => {
      setLoading(false);
      const { errorCode } = result;
      if(errorCode === NotFoundErrorCode) {
        history.replace(Routes.pageNotFound());
        return;
      }
      props.showServerErrorIfNeed(result);
    })
  }, [])

  const classes = pageStyles();

  const { name, headline, downloadable, sanitizedContent, sanitizedExtraContent } = page;

  const onChangeEmail = (value) => {
    setSubscribeEmail(value);
  }

  return (
    <div className = { classes.root } >
      {
        !loading &&
        <Container className = { classes.container }>
          <h1>
            { name }
          </h1>
          <HtmlContent>
            { sanitizedContent }
          </HtmlContent>
          {
            downloadable && <SubscribeBlock setSubscribeEmail = { onChangeEmail }
              subscribeEmail = { subscribeEmail }
              subscribe = { subscribe }
              headline = { headline }
              submitting = { submitting }  />
          }
          <HtmlContent>
            { sanitizedExtraContent }
          </HtmlContent>
          <Switch>
            <Route path = { `${Routes.contacts()}` }
                  render = { () => {
              return <ContactsForm className = { classes.contactForm } />
            }} />
            <Route render = { () => {
              return <React.Fragment />
            }} />
          </Switch>
      </Container>
     }
    </div>
  );
}

export default compose(withRouter, withShowToast)(StaticPage);
